import type { FilterSectionConfig } from "@/shared/components/common/ListFilterPopover";
import { TENANT_USER_ACCOUNT_STATUS_OPTIONS } from "@/features/tenantUsers/constants";

/**
 * Teachers list filters: board, class and section are free-text inputs, status
 * is a dropdown (Active, Inactive, Pending, Marked for delete).
 */
export function getTeachersListFilterSections(
  t: (key: string) => string,
): FilterSectionConfig[] {
  return [
    {
      key: "board",
      label: t("teachers:filter.board"),
      options: [],
      type: "text",
      placeholder: t("teachers:filter.placeholder.board"),
    },
    {
      key: "class",
      label: t("teachers:filter.class"),
      options: [],
      type: "text",
      placeholder: t("teachers:filter.placeholder.class"),
    },
    {
      key: "section",
      label: t("teachers:filter.section"),
      options: [],
      type: "text",
      placeholder: t("teachers:filter.placeholder.section"),
    },
    {
      key: "accountStatus",
      label: t("teachers:filter.accountStatus"),
      options: [...TENANT_USER_ACCOUNT_STATUS_OPTIONS],
      type: "searchable-select",
      placeholder: t("teachers:filter.placeholder.status"),
    },
  ];
}